import { useParams, useNavigate } from 'react-router-dom';
import { Icon, Button } from '@/components/atoms';
import { GRNDetail } from '@/components/organisms/GRN/GRNDetail';
import { AttachmentList } from '@/components/organisms/Attachment/AttachmentList';

export default function GRNDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="p-8">
        <div className="bg-error-50 border border-error-200 rounded-lg p-6">
          <div className="flex items-start gap-4">
            <div className="bg-error-100 p-2 rounded-lg">
              <Icon name="CircleAlert" size={24} className="text-error-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-error-900 mb-1">Invalid GRN</h3>
              <p className="text-error-700 mb-3">No GRN ID provided in the URL.</p>
              <Button variant="primary" size="sm" onClick={() => navigate('/grns')}>
                <Icon name="ArrowLeft" size={16} className="mr-2" />
                Back to GRNs
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/grns')}>
          <Icon name="ArrowLeft" size={16} className="mr-2" />
          Back to GRNs
        </Button>
      </div>

      <GRNDetail grnId={id} />

      {/* GRN Attachments */}
      <div className="bg-white rounded-lg border border-neutral-200 p-6">
        <AttachmentList
          entityType="grn"
          entityId={id}
          allowUpload={true}
          allowDelete={true}
          viewMode="list"
        />
      </div>
    </div>
  );
}
